import { render, staticRenderFns } from "./NominationConferenceCreate.vue?vue&type=template&id=b6a0ce16&scoped=true"
import script from "./NominationConferenceCreate.vue?vue&type=script&lang=js"
export * from "./NominationConferenceCreate.vue?vue&type=script&lang=js"
import style0 from "./NominationConferenceCreate.vue?vue&type=style&index=0&id=b6a0ce16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a0ce16",
  null
  
)

export default component.exports